var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6579 9.08839C18.877 8.85897 19 8.5478 19 8.22335C19 7.8989 18.877 7.58773 18.6579 7.35831C18.4389 7.12889 18.1419 7 17.8321 7C17.5224 7 17.2253 7.12889 17.0063 7.35831L9.66716 15.0484L6.99372 12.2455C6.7747 12.0161 6.47764 11.8872 6.16789 11.8872C5.85815 11.8872 5.56109 12.0161 5.34207 12.2455C5.12305 12.475 5 12.7861 5 13.1106C5 13.435 5.12305 13.7462 5.34207 13.9756L8.84133 17.641C8.94968 17.7548 9.0784 17.8451 9.22011 17.9067C9.36182 17.9683 9.51373 18 9.66716 18C9.82058 18 9.9725 17.9683 10.1142 17.9067C10.2559 17.8451 10.3846 17.7548 10.493 17.641L18.6579 9.08839Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.b6004544db11c8c94d096a7903a664cd.svg";
export { ForwardRef as ReactComponent };